/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { array } from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    grid: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 88, maxWidth: 1008, margin: '0 auto', '@media (max-width: 760px)': { gap: 24 }, '@media (max-width: 600px)': { gridTemplateColumns: '1fr', gap: 20, maxWidth: 460 } },
    link: { display: 'block', overflow: 'hidden', '& img': { display: 'block', width: '100%', height: 'auto', transition: 'transform 180ms ease' }, '&:hover img': { transform: 'scale(1.02)' }, '&:focus-visible': { outline: '3px solid #329A77', outlineOffset: 3 } },
}));

const PassportLanderOffers = ({ offers }) => {
    const classes = useStyles();
    return (
        <div className={classes.grid} data-component="passportLanderOffers">
            {offers.map((offer, index) => {
                const image = offer?.image;
                const href = offer?.link?.href;
                if (!image?.url) return null;
                const content = <img src={image.url} alt={image.title || `Member offer ${index + 1}`} />;
                return href ? <Link className={classes.link} to={href} key={offer?._metadata?.uid || image.uid || index}>{content}</Link>
                    : <div className={classes.link} key={offer?._metadata?.uid || image.uid || index}>{content}</div>;
            })}
        </div>
    );
};
PassportLanderOffers.propTypes = { offers: array.isRequired };
export default PassportLanderOffers;
